import {makeEl} from "../../../common/Utils";
import DataStore from "../../DataStore";
import {infoType} from "../../../interface/IFooter";

export default class infoCS{
    private ds : DataStore

    constructor(_wrapper: HTMLElement, _csInfoType: infoType) {
        this.ds = DataStore.instance;
        const infoCSString = this.ds.l10n.infoCS[_csInfoType];

        if(infoCSString){
            this.templ(_wrapper, infoCSString, _csInfoType);
        }
    }

    templ(_parent: HTMLElement, _data: string, _infoType: infoType){
        makeEl('address', _parent, {class: 'footer-info-address'}).innerHTML = `
            ${this.ds.l10n.infoCS.infoAddress}
            <a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1448504244" target="_blank">
                <strong>${this.ds.l10n.infoCS.businessInformation}</strong>
            </a>`;

        type emailkeyType = "infoEmail-pc" | "infoEmail-mobile" | "infoEmail-other";
        let emailkey: emailkeyType = "infoEmail-"+_infoType as emailkeyType;

        if (_infoType==='other') {
            const mailArr = this.ds.l10n.infoCS["infoEmail-other"].split('/');
            makeEl('div', _parent, {class: 'footer-info-cs'}).innerHTML = `
                ${_data}
                <span class="footer-info-email">
                    ${this.ds.l10n.infoCS.infoEmail}
                    <a href="mailto:${mailArr[0]}" class="email">${mailArr[0]}</a>${mailArr[1]}
                    <a href="mailto:${mailArr[2]}" class="email">${mailArr[2]}</a>${mailArr[3]}
                </span>`;
        } else {
            makeEl('div', _parent, {class: 'footer-info-cs'}).innerHTML = `
                ${_data}
                <span class="footer-info-email">
                    ${this.ds.l10n.infoCS.infoEmail}
                    <a href="mailto:${this.ds.l10n.infoCS[emailkey]}" class="email">${this.ds.l10n.infoCS[emailkey]}</a>
                </span>`;

        }
    }
}
